
import { defineComponent } from 'vue';
import NFTCard2 from '@/components/gem-bank/NFTCard2.vue';

export default defineComponent({
  components: { NFTCard2 },
  emits: ['selected'],
  props: {
    title: String,
    nfts: Array,
  },
  setup(props, ctx) {
    const handleSelected = (e: any) => {
      ctx.emit('selected', e);
    };
    return {
      handleSelected,
    };
  },
});
